import { render, staticRenderFns } from "./ApiSmsTemplate.vue?vue&type=template&id=92271b80&scoped=true"
import script from "./ApiSmsTemplate.vue?vue&type=script&lang=js"
export * from "./ApiSmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ApiSmsTemplate.vue?vue&type=style&index=0&id=92271b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92271b80",
  null
  
)

export default component.exports